import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-439897f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "heading"
}
const _hoisted_2 = {
  key: 1,
  class: "result mb20"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("正解")
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("不正解")
const _hoisted_7 = {
  key: 0,
  class: "mt10"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "sub-heading" }, "選択してください", -1))
const _hoisted_11 = {
  key: 0,
  class: "text-left"
}
const _hoisted_12 = {
  key: 1,
  class: "mb10 text-left"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("これが正解！")
const _hoisted_14 = { class: "text-left" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 0,
  class: "result mb20"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("正解")
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("不正解")
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "sub-heading" }, "解説", -1))
const _hoisted_23 = { key: 0 }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "mt10 fs14" }
const _hoisted_26 = { class: "mt10" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("回答送信")
const _hoisted_28 = { class: "mt10" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("出題")
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs14" }, "履歴確認", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs14" }, "すべての問題に回答をしています", -1))

import { ref, computed } from "vue";
import { LearningCourse } from "@/types/learning_course";
import { LearningQuestionResult } from "@/types/learning_question_result";
import { LearningCourseQuestion } from "@/types/LearningCourseQuestion";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTimesCircle,
  faCheckCircle
} from "@fortawesome/free-solid-svg-icons";
import ConfettiExplosion from "vue-confetti-explosion";

// import axios from "axios";
interface Props {
  project_id: number;
  learning_course_id: number;
  learning_course: LearningCourse | null;
  learning_course_question: LearningCourseQuestion | null;
  learning_question_result: LearningQuestionResult | null;
  loading: boolean;
  exists_unanswerd: boolean;
}
interface Emits {
  (e: "loadLearningCourseQuestion"): void;
  (
    e: "sendAnswer",
    _learning_id: number,
    _answer_time: number,
    _answer_ids: number[]
  ): LearningQuestionResult;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    project_id: { type: Number, required: true },
    learning_course_id: { type: Number, required: true },
    learning_course: { type: null, required: true },
    learning_course_question: { type: null, required: true },
    learning_question_result: { type: null, required: true },
    loading: { type: Boolean, required: true },
    exists_unanswerd: { type: Boolean, required: true }
  },
  emits: ["loadLearningCourseQuestion", "sendAnswer"],
  setup(__props: any, { emit }: { emit: ({
  (e: "loadLearningCourseQuestion"): void;
  (
    e: "sendAnswer",
    _learning_id: number,
    _answer_time: number,
    _answer_ids: number[]
  ): LearningQuestionResult;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  project_id: number;
  learning_course_id: number;
  learning_course: LearningCourse | null;
  learning_course_question: LearningCourseQuestion | null;
  learning_question_result: LearningQuestionResult | null;
  loading: boolean;
  exists_unanswerd: boolean;
}
library.add(faTimesCircle, faCheckCircle);



// const store = useStore();
let choice_ids = ref<number[]>([]);
let start_time = Date.now()
const selectChoice = (choice_id: number) => {
  if (props.learning_question_result != null) {
    return
  }
  if (props.learning_course_question == null) {
    return
  }
  if (choice_ids.value.includes(choice_id)) {
    choice_ids.value = choice_ids.value.filter(item => item != choice_id)
  } else {
    if (props.learning_course_question.only_one_select_flg) {
      choice_ids.value = [choice_id]
    } else {
      choice_ids.value.push(choice_id)
    }
  }
};
const sendAnswer = () => {
  if (props.learning_course_question && props.learning_course_question) {
    var delta = Date.now() - start_time;
    const answer_time = Math.floor(delta / 1000);
    emit("sendAnswer", props.learning_course_question.id, answer_time, choice_ids.value);
  }
};
// 問題がある時
const visibleNextLearning = computed(() => {
  if (props.exists_unanswerd == false) {
    return false;
  }
  return (
    (props.learning_question_result &&
      props.learning_question_result.answer_ids.length > 0) ||
    props.learning_course_question == null
  );
});
const loadLearning = () => {
  choice_ids.value = [];
  emit("loadLearningCourseQuestion");
  start_time = Date.now()
};

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.learning_course)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(__props.learning_course.name), 1))
      : _createCommentVNode("", true),
    (__props.learning_question_result != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (__props.learning_question_result.correct == true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_el_tag, {
                  type: "success",
                  class: "tag-redius tag-big",
                  effect: "dark"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]))
            : (__props.learning_question_result.correct == false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_el_tag, {
                    class: "tag-redius tag-big",
                    effect: "dark"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", null, [
      (__props.learning_course_question)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (__props.learning_course_question.code == 'found')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_card, {
                      class: "title text-left",
                      shadow: "never"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          innerHTML: __props.learning_course_question.question,
                          class: "fs14-normal"
                        }, null, 8, _hoisted_9)
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_10,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.learning_course_question.choices, (choice) => {
                    return (_openBlock(), _createBlock(_component_el_card, {
                      key: choice.id,
                      class: _normalizeClass(["choice mt10 fs14", {
            correct: __props.learning_question_result && __props.learning_question_result.answer_ids.includes(choice.id),
            select: _unref(choice_ids).includes(choice.id),
          }]),
                      shadow: "never",
                      onClick: ($event: any) => (selectChoice(choice.id))
                    }, {
                      default: _withCtx(() => [
                        (__props.learning_question_result)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                          : _createCommentVNode("", true),
                        (
              __props.learning_question_result &&
              __props.learning_question_result.answer_ids.includes(choice.id)
            )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createVNode(_component_el_tag, {
                                type: "success",
                                class: "tag-redius",
                                effect: "dark"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_13
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("span", {
                            innerHTML: choice.content
                          }, null, 8, _hoisted_15)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onClick", "class"]))
                  }), 128)),
                  (__props.learning_question_result != null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        (__props.learning_question_result.correct == true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createVNode(_unref(ConfettiExplosion)),
                              _createVNode(_component_el_tag, {
                                type: "success",
                                class: "tag-redius tag-big",
                                effect: "dark",
                                id: "correct"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_18
                                ]),
                                _: 1
                              })
                            ]))
                          : (__props.learning_question_result.correct == false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createVNode(_component_el_tag, {
                                  class: "tag-redius tag-big",
                                  effect: "dark"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_20
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (__props.learning_question_result)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _hoisted_22,
                        _createVNode(_component_el_card, {
                          class: "text-left mt10 fs14",
                          shadow: "never"
                        }, {
                          default: _withCtx(() => [
                            (__props.learning_question_result.commentary.replace(/<p>|<\/p>|<br>/g, '').length == 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, "解説なし"))
                              : (__props.learning_question_result.commentary)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    innerHTML: __props.learning_question_result.commentary
                                  }, null, 8, _hoisted_24))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(__props.learning_course_question.learning_progress), 1),
                  _withDirectives(_createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_el_button, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (sendAnswer())),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_27
                      ]),
                      _: 1
                    })
                  ], 512), [
                    [_vShow, _unref(choice_ids).length > 0 && __props.learning_question_result == null]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_28, [
        _withDirectives(_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (loadLearning())),
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_29
          ]),
          _: 1
        }, 512), [
          [_vShow, _unref(visibleNextLearning)]
        ]),
        (__props.loading == false && __props.exists_unanswerd == false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, {
                  to: {
              name: 'ProjectLearningCourseHistory',
              params: {
                project_id: _ctx.$route.params.project_id,
                learning_course_id: __props.learning_course_id
              }
            }
                }, {
                  default: _withCtx(() => [
                    _hoisted_31
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _hoisted_32
            ]))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_directive_loading, __props.loading]
    ])
  ], 64))
}
}

})